<template>
  <b-row v-if="cenarios.length > 0">
    <b-col cols="12 mt-1">
      <div class="card card-aviso">
        <div class="card-header">
          <h4 class="card-title text-danger fw-bold fz-15">IMPORTANTE - LEIA COM ATENÇÃO</h4>
        </div>
        <!-- /.card-header -->
        <div class="card-body text-danger">
          <p class="fz-12">As informações referentes a Preços, Redes, Carências, Documentações, Reembolsos e Condições Contratuais são <b>determinadas pelas</b> operadoras, seguradoras, 
              administradoras ou outras entidades responsáveis e <b>deverão ser verificadas e conferidas junto</b> à respectiva <b>antes da CONTRATAÇÃO.</b></p>
          <p class="fz-12">Esta é uma <b>ferramenta de simulação</b> destinada a auxiliar no processo de pesquisa. Contudo, é importante destacar que <b>não nos responsabilizamos por possíveis 
          alterações que sejam feitas sem prévio aviso</b>. Para maiores informações e rede credenciada, consulte o site oficial da operadora. Quaisquer outras <b>dúvidas consulte o 
          corretor</b> que lhe enviou esta simulação.</p>
          <p class="fz-12"><b>Ressaltamos o nosso compromisso com a precisão das informações fornecidas</b>, no entanto, reservamo-nos o direito de corrigir eventuais erros identificados, esclarecendo 
          que tais correções <b>não estão vinculadas à efetivação do serviço</b>, que ocorrerá exclusivamente mediante a assinatura do contrato.</p>
          <p class="fz-12"><i>Aos valores apresentados não estão sendo somadas as taxas (exceto quando informado).</i></p>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters('cenario', {
      cenarios: 'getCenarios'
    }),
  }
}
</script>

<style>

</style>
